module.exports = __webpack_public_path__ + "static/media/kaylo-logo.89d31421.png";